export default __webpack_public_path__ + "static/media/Proxima-Nova-Light-It.de4b7901.ttf";